import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// import 'es6-promise/auto'
import App from './App'
import router from './router'
import axios from 'axios'
import Default from "./layouts/Default.vue"
import NoSidebar from "./layouts/NoSidebar.vue"
import store from './store/store'

Vue.component('default-layout', Default)
Vue.component('no-sidebar-layout', NoSidebar);

Vue.config.productionTip = false;

Vue.prototype.axios = axios

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  components: {
    App,
   },
  template: '<router-view/>'
})



// WEBPACK FOOTER //
// ./src/main.js